import { ServiceBase } from "@app/shared";
import { querystringify } from "@app/shared/utility";
import { NetworkIntegritySummaryResult } from "@app/projects/results/networkIntegrity/networkIntegritySummaryResult";

export default class NetworkIntegrityService extends ServiceBase {
  public async getNetworkSummaryResult(customProjectId: number, projectRunConfigurationId: number, providerType: string): Promise<NetworkIntegritySummaryResult> {
    return await this.makeGet<NetworkIntegritySummaryResult>(`networkintegrity/network-summary-result?${querystringify({ customProjectId, projectRunConfigurationId, providerType })}`);
  }
}